export default __webpack_public_path__ + "static/media/grafica.b7334dfe.jpg";